import React  from "react"
import useSelfCheckinNafigation from 'utils/useSelfCheckinNafigation';
import Grid from '@mui/material/Grid';
import sitaLogoW from "assets/images/sitaLogoW.png"
import portalSita from "assets/images/portalSita.png"
import { useTranslation } from 'react-i18next';
import {AppRoutes} from "utils/routes";
import {
  ButtonTypeEnum, ButtonSizeEnum, ButtonColorEnum, SelfCheckinStepEnum
} from "components/shared/enums/global-enums.tsx";

import useStore from 'store/store'
import AppButton from "components/shared/AppButton/AppButton"
import './Footer.scss'

export default function Footer({backStep=-1, backAddFunc, forwordStep=1, forwordAddFunc, forwordTitle="Proceed", forceFooter=false}){
  const {t} = useTranslation();
  const [redirect, activeStep] = useSelfCheckinNafigation();
  const storeActions = useStore((state)=> state.actions);
  const touchpointType = storeActions.retrieveItem("touchpoint-type");


  let imgLogo = portalSita;
  if (touchpointType === "NON-POPPS") imgLogo = sitaLogoW;
    

  return (

    <Grid className="d-f jc-r floating-footer" container spacing={2}>
      <Grid item xs={4} >
        
        {((activeStep > SelfCheckinStepEnum.SCAN_PASSPORT && activeStep <= SelfCheckinStepEnum.ITEMS_TO_PRINT) || forceFooter) && <AppButton 
          sx={{paddingLeft: 5, paddingRight: 5}}
          buttonLabel={ t("Cancel") }
          buttonType={ButtonTypeEnum.PRIMARY}
          buttonSize={ButtonSizeEnum.SMALL}
          buttonColor={ButtonColorEnum.SECONDARY1_BG}
          onClickFunc={()=>{
            if (backStep !== 0) redirect(backStep);
            try { backAddFunc(); } catch(e) {}
            }
          }
        />}
        
      </Grid>
      <Grid item xs={4}  >
        <div className="c-txt">
          <img onClick={()=>{
                if (window.location.pathname === AppRoutes.selfCheckinPath){
                  storeActions.fakePassport(redirect)
                  
                }
              }
            } src={imgLogo} alt=""/>
        </div>
      </Grid>
      <Grid item xs={4} className="d-f jc-r" >
        {((activeStep >= SelfCheckinStepEnum.PASSENGER && activeStep <= SelfCheckinStepEnum.ITEMS_TO_PRINT) || forceFooter)  &&  <AppButton 
          sx={{paddingLeft: 5, paddingRight: 5}}
          buttonLabel={ t(forwordTitle) }
          buttonType={ButtonTypeEnum.PRIMARY}
          buttonSize={ButtonSizeEnum.SMALL}
          buttonColor={ButtonColorEnum.SECONDARY1_BG}
          onClickFunc={()=>{
            if (forwordStep !== 0) redirect(forwordStep);
            try { forwordAddFunc(); } catch(e) {}
            }
          }
        />}
      </Grid>
    </Grid>
    
    )
}